var _defs, _circle, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 319 250",
    style: {
      enableBackground: "new 0 0 319 250"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0F9FF;}\r\n\t.st1{clip-path:url(#SVGID_4_);}\r\n\t.st2{fill:#E58676;}\r\n\t.st3{fill:#FFE3D1;}\r\n\t.st4{fill:#FFA694;}\r\n\t.st5{fill:#4F332E;}\r\n\t.st6{fill:#EFBCA0;}\r\n\t.st7{fill:#1A8476;}\r\n\t.st8{fill:#8C8F99;}\r\n\t.st9{fill:#B4B2C2;}\r\n\t.st10{fill:#AEB2BE;}\r\n\t.st11{fill:#A7D5F7;}\r\n\t.st12{fill:#076D5C;}\r\n\t.st13{fill:#FFFFFF;}\r\n\t.st14{fill:#ED5702;}\r\n\t.st15{fill:#FABF48;}\r\n\t.st16{fill:#E09819;}\r\n\t.st17{fill:#22231E;}\r\n\t.st18{fill:#FBE6D5;}\r\n\t.st19{fill:#E07D6C;}\r\n\t.st20{fill:#C2573C;}\r\n\t.st21{fill:#502B25;}\r\n\t.st22{fill:#512C26;}\r\n\t.st23{fill:#6D9AFF;}\r\n\t.st24{fill:#3B7DF2;}\r\n\t.st25{fill:#C44405;}\r\n"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0.07855301350355148, 1, -39.61207580566406, -1.9524240493774414)",
    style: {}
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 159.5,
    cy: 130,
    r: 120
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299,93.7h-99.5c0,0-6.7,14.7-8.5,14.7c-1.3,0-0.3-14.7-0.3-14.7h-5.7c-1.1,0-1.9-0.9-1.8-2l8.4-71.7 c0.1-0.9,0.9-1.6,1.8-1.6h114.1c1.1,0,1.9,0.9,1.8,2l-8.4,71.7C300.7,93,299.9,93.7,299,93.7z",
    style: {
      clipPath: "none",
      fill: "rgb(253, 219, 109)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 300.9,
    cy: 24.9,
    r: 2.8,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 291.7,
    cy: 24.9,
    r: 2.8,
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M231.9,31.1c-3,3-4.6,7.3-4.5,11.5c0.1,1.8,0.5,3.8-0.4,5.4c-0.7,1.5-1.5,1.6-2.9,3.9 c-1.5,2.4-1.1,5.3-0.6,6.7c0.6,1.8,2,2.5,3.3,3.1c1.3,0.6,15.7,2.6,16.2-5c0.5-7.6,1.9-12,1.7-13.8L231.9,31.1z",
    style: {
      fill: "rgb(47, 44, 73)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M233.8,52.1c-0.7-1.1-0.5-2.4-0.1-3.6c0.3-1.2,0.7-2.4,0.8-3.7c0.1-1.3-0.1-2.5-0.2-3.7 c-0.1-1.2,0-2.5,0.9-3.3c0.4-0.4-0.2-1-0.7-0.7c-2.1,1.9-0.8,5.1-0.9,7.5c-0.1,2.6-2,5.4-0.5,7.9 C233.3,53.1,234.1,52.6,233.8,52.1L233.8,52.1z",
    style: {
      fill: "rgb(47, 44, 73)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M269.3,42.2c-0.6-0.6-1.3-1-1.9-1.6c-1.6-1.8-1.4-4.6-1.9-7c-0.4-1.8-1.2-3.5-2.3-4.9 c-1.3-1.6-3.1-2.8-4.5-4.3c-1.5-1.5-2.7-3.4-2.6-5.5c0,0-4.6-1.6-4.9,3.2c-0.1,1,0.1,2.9,0.5,5.2c-2.2,0-4.2,0.3-4.2,0.3 c-1,3.6-1.9,7.4-0.7,10.9c0.6,1.8,1.9,3.4,2.3,5.3c0.5,2.1-0.2,4.9,0,7.1c0.3,3.6,2.5,5.8,5.6,6.3c6.2,1,15.2-2,17.4-5.8 C273.9,48.3,271.8,44.4,269.3,42.2z",
    style: {
      fill: "rgb(47, 44, 73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M217.9,93.7c0,0-0.7-26.3,3.9-35.3c4.7-9,27.2-12.8,27.2-12.8s17.9-2.7,27.3,4c8.2,5.9,9.8,14.1,11.5,27.1 c1.4,10.7,2.3,17,2.3,17H217.9z",
    style: {
      fill: "rgb(199, 228, 242)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "192.6,77.6 198.8,86.7 211.9,76.6 203.3,66.2 \t\t\t\t\t",
    style: {
      fill: "rgb(255, 165, 143)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "197.2,85.5 211.9,76.6 226.7,93.6 202.3,93.6 \t\t\t\t\t",
    style: {
      fill: "rgb(199, 228, 242)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M245.8,49c0.3,11.3,1,22.6,2,33.8c0.3,3.2,0.6,6.4,1,9.6c0.1,0.6,1,0.6,0.9,0 c-1.3-11.2-2.1-22.5-2.6-33.8c-0.1-3.2-0.3-6.4-0.3-9.6C246.7,48.4,245.8,48.4,245.8,49L245.8,49z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M240.1,47.4c-0.3,2.3-0.5,4.5-0.8,6.8c-0.1,0.5-0.2,1-0.1,1.5c0.1,0.5,0.6,1,1.1,0.9 c0.7-0.1,1.2-0.8,1.7-1.2c0.5-0.5,1.1-1,1.6-1.6c1.2-1.2,2.3-2.6,3.3-3.9c0.4-0.5-0.4-0.9-0.8-0.5c-1,1.4-2.1,2.7-3.3,3.9 c-0.5,0.6-1.1,1.1-1.7,1.7c-0.1,0.1-0.7,0.8-0.9,0.7c-0.2-0.1,0-0.6,0-0.8c0.3-2.5,0.6-4.9,0.8-7.4 C241.1,46.8,240.1,46.8,240.1,47.4L240.1,47.4z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M255.6,45c0.3,2.5,0.6,5,1,7.6c0.1,0.6,0.1,1.1,0.2,1.7c0,0.2,0.1,0.4,0.1,0.6c0,0.4,0.1,0.8-0.4,0.7 c-0.7-0.2-1.4-0.9-2-1.3c-0.7-0.5-1.4-1-2.1-1.5c-1.6-1.2-3.1-2.4-4.6-3.7c-0.4-0.4-1.1,0.3-0.7,0.7c1.4,1.2,2.9,2.4,4.4,3.6 c0.8,0.6,1.6,1.2,2.4,1.8c0.7,0.5,1.4,1.1,2.1,1.4c0.8,0.3,1.6,0.1,1.8-0.8c0.1-0.5,0-1.2-0.1-1.7c-0.2-1.5-0.4-2.9-0.6-4.4 c-0.2-1.5-0.4-3-0.6-4.5C256.5,44.4,255.5,44.4,255.6,45L255.6,45z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M231.9,70.6c-0.6,2.2-1.3,4.4-1.9,6.7c-0.6,2.1-1.1,4.3-0.8,6.5c0.4,3.2,3.5,5.9,6.7,6 c0.6,0,0.6-0.9,0-0.9c-1.5-0.1-2.9-0.8-4-1.8c-1.3-1.2-1.8-2.6-1.9-4.4c0-2,0.5-4,1.1-5.9c0.6-2,1.1-3.9,1.7-5.9 C232.9,70.2,232,70,231.9,70.6L231.9,70.6z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M256.2,90.2c2.7,0.9,5.6,0.7,8.1-0.6c2.2-1.1,4-3.1,4.9-5.4c0.2-0.5-0.7-0.8-0.9-0.2 c-1.9,4.6-7.2,6.9-11.9,5.4C255.9,89.1,255.6,90,256.2,90.2L256.2,90.2z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M268.4,73.9c-0.1,6.5,0,13,0.2,19.5c0,0.6,0.9,0.6,0.9,0c-0.3-6.5-0.3-13-0.2-19.5 C269.3,73.3,268.4,73.3,268.4,73.9L268.4,73.9z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233.8,89.2c0,1.2,0,2.5,0,3.7c0,0.6,0.9,0.6,0.9,0c0-1.2,0-2.5,0-3.7C234.8,88.6,233.8,88.6,233.8,89.2 L233.8,89.2z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217.9,84.6c2.4,3.1,4.8,6.1,7.3,9.1c0.4,0.5,1-0.2,0.7-0.7c-2.4-3-4.9-6.1-7.3-9.1 C218.2,83.4,217.5,84.1,217.9,84.6L217.9,84.6z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M201.9,92c4.9-3,9.9-6,14.9-8.9c0.5-0.3,0-1.1-0.5-0.8c-5,2.9-10,5.9-14.9,8.9 C200.9,91.5,201.4,92.3,201.9,92L201.9,92z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M199.1,63.4c-2.5-1.1-5.3-1.9-8-2.3c-1.2-0.2-2.4-0.3-3.7-0.5c-2.5-0.3-5.8-0.5-6.2,0.7 c-0.8,2.5,4.2,3.7,4.2,3.7c-7-0.2-12,0.2-12.9,1.7c-0.4,0.7-0.4,1.7,0.7,2c0,0-0.7,0.1-1.4,0.6c-0.7,0.6-1.1,2.4,2.2,2.9 c0,0-1.9,0.6-1.9,1.7c-0.1,1.3,1,1.9,3.2,2.1c2.3,0.2,16.9,2.3,19.3,2c10-1.1,10.5-8.7,10.5-8.7 C204.2,66.7,202.6,65,199.1,63.4z",
    style: {
      fill: "rgb(255, 165, 143)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M173.2,69.2c3.7,0,7.3,0,11,0c0.6,0,0.6-0.9,0-0.9c-3.7,0-7.3,0-11,0C172.6,68.2,172.6,69.2,173.2,69.2 L173.2,69.2z",
    style: {
      fill: "rgb(242, 129, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M173.9,72.7c3.7,0,7.3,0,11,0c0.6,0,0.6-0.9,0-0.9c-3.7,0-7.3,0-11,0C173.3,71.8,173.3,72.7,173.9,72.7 L173.9,72.7z",
    style: {
      fill: "rgb(242, 129, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M185.2,65.6c1.5,2.7,4.2,4.6,7.3,5.1c0.6,0.1,0.8-0.8,0.2-0.9c-2.8-0.5-5.3-2.2-6.7-4.7 C185.7,64.6,184.9,65.1,185.2,65.6L185.2,65.6z",
    style: {
      fill: "rgb(242, 129, 107)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "253.9,45.1 246.2,51.2 242.5,47.3 239.8,36.2 249.1,30.7 \t\t\t\t\t",
    style: {
      fill: "rgb(255, 165, 143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M255.1,17.5c-1.6-7.7-8.4-8.7-15.4-6.3c-7,2.4-8.5,5.7-8.9,12c-0.4,6.3,0.2,12.4,0.8,14.5 c1.2,4.3,3.8,7.4,9.1,5.1c5.4-2.3,7.4-6,9.7-8.9C252.1,31.8,256.7,25.2,255.1,17.5z",
    style: {
      fill: "rgb(255, 165, 143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M232.9,28.6c-0.1-0.2-0.4-0.4-0.7-0.4c-0.3,0-0.6,0.3-0.7,0.6c-0.1,0.3-0.1,0.7-0.1,1 c0,0.4,0.1,0.8,0.3,1.1c0.4,0.5,1.1,0.2,1.3-0.3C233.2,30,233.1,29,232.9,28.6z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M238.8,28.6c-0.1-0.2-0.4-0.4-0.7-0.4c-0.3,0-0.6,0.3-0.7,0.6c-0.1,0.3-0.1,0.7-0.1,1 c0,0.4,0.1,0.8,0.3,1.1c0.4,0.5,1.1,0.2,1.3-0.3C239.2,30,239.1,29,238.8,28.6z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M255.6,16.5c-2-7.6-9.8-8.8-16.7-5.9c-5.7,2.3-8.7,5.6-7.8,10.3c1.6-1.5,2.8-2.1,4.2-2.2 c0.1,0.9,0.7,2.5,2.1,3.4c0.4,0.3,1.4,0.6,2,0.7c2.7,0.7,3.5,1.4,5,3.5c0,0,0,0,0,0c0.2,0.5,0.5,1,0.9,1.6 c1.3,1.7-2.1,8.2,6.3,10.2c0.5,0.1,5.8-5.6,6.3-5.6C260.3,29.4,256.9,21.6,255.6,16.5z",
    style: {
      fill: "rgb(47, 44, 73)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M266.3,44.8c-2.3-1.7-2.8-4.5-3.7-7c-0.5-1.4-1-2.8-1.7-4c-0.7-1.3-1.7-2.3-2.8-3.4c-1-1-2.1-2-2.8-3.3 c-0.7-1.4-0.8-3-1.2-4.5c-0.6-2.5-1.8-4.7-3.9-6.3c-1.1-0.9-2.3-1.5-3.4-2.5c-1.2-1.1-2.2-2.4-2.8-3.9 c-0.2-0.6-1.1-0.3-0.9,0.2c0.5,1.4,1.3,2.6,2.3,3.7c0.9,0.9,2,1.6,3,2.3c2.2,1.5,3.8,3.4,4.5,6c0.4,1.6,0.5,3.3,1.2,4.8 c0.5,1.3,1.4,2.4,2.4,3.4c1,1,2.2,2,3,3.3c0.9,1.3,1.4,2.8,1.9,4.3c0.5,1.5,0.9,3,1.5,4.5c0.6,1.3,1.4,2.4,2.6,3.3 C266.3,46,266.7,45.2,266.3,44.8L266.3,44.8z",
    style: {
      fill: "rgb(47, 44, 73)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M248.3,28.5c0.5,2-0.7,4.1-2.7,4.7c-2,0.5-4.1-0.7-4.7-2.7c-0.5-2,0.7-4.1,2.7-4.7 C245.6,25.2,247.7,26.5,248.3,28.5z",
    style: {
      fill: "rgb(255, 165, 143)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M234.7,29.2c-0.2,0.5-0.5,1-0.7,1.6c-0.2,0.5-0.5,1-0.7,1.6c-0.2,0.5-0.1,1.2,0.5,1.3 c0.5,0.1,1.1,0,1.6-0.2c0.2-0.1,0.4-0.3,0.3-0.6c-0.1-0.2-0.3-0.4-0.6-0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2,0-0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0.1-0.2,0.2-0.4,0.2-0.5 c0.4-0.8,0.8-1.7,1.2-2.5c0.1-0.2,0.1-0.5-0.2-0.6C235.1,29,234.8,29,234.7,29.2L234.7,29.2z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M244.8,28.1c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0.1 c0,0,0.1,0,0.1,0c-0.1,0,0,0,0,0c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0.1c-0.1,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1 c0,0,0.1,0.1,0,0c0,0,0,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0.1,0.1,0,0.1c0-0.1,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1c0-0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0-0.1,0,0c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1 c0,0.1,0-0.1,0,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0,0.6-0.2c0.5-0.7,0.5-1.7,0-2.4 c-0.4-0.7-1.3-1.1-2.1-1c-0.2,0-0.5,0.2-0.5,0.5C244.4,27.9,244.6,28.2,244.8,28.1L244.8,28.1z",
    style: {
      fill: "rgb(242, 129, 107)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.8,43.4c1.1-0.6,2.2-1.3,3.1-2.1c0.2-0.2,0.2-0.5,0-0.7c-0.2-0.2-0.5-0.2-0.7,0 c-0.9,0.8-1.8,1.5-2.9,2c-0.2,0.1-0.3,0.4-0.2,0.6C241.3,43.5,241.6,43.5,241.8,43.4L241.8,43.4z",
    style: {
      fill: "rgb(242, 129, 107)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M233.6,35.7l4.7-0.8c0,0-0.1,1.9-2,2.3C234.3,37.5,233.6,35.7,233.6,35.7z",
    style: {
      fill: "rgb(255, 234, 224)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M236.2,26.4c0.3,1.2,1.3,0.4,2.6,0.9c1.2,0.4,2,0.4,2-0.3c0.1-0.8-1-1.9-2.8-2 C236.5,24.8,236,25.5,236.2,26.4z",
    style: {
      fill: "rgb(47, 44, 73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M233.9,26.5c-0.2,1.2-1.3,0.5-2.6,1c-0.2,0.1-0.4,0.2-0.6,0.2c-0.5-0.6-0.5-1.6,0-2.2 c0.4-0.2,0.7-0.3,1.2-0.3C233.5,25,234.1,25.6,233.9,26.5z",
    style: {
      fill: "rgb(47, 44, 73)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M235.8,18.4c0.4-2,1.7-3.6,3.2-5c1.7-1.5,3.8-2.6,5.9-3.3c0.6-0.2,0.3-1.1-0.2-0.9 c-2.3,0.7-4.5,1.9-6.3,3.6c-1.6,1.4-3,3.2-3.4,5.4C234.8,18.8,235.6,19,235.8,18.4L235.8,18.4z",
    style: {
      fill: "rgb(47, 44, 73)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M238.6,13c0.2,2.5,1.4,5.1,3.3,6.7c1.1,1,2.5,1.5,3.8,2.2c1.2,0.7,2.3,1.7,3,2.9c0.8,1.2,1.3,2.6,1.6,4 c0.4,1.4,0.7,2.8,1.4,4.1c0.6,1.1,1.6,2,2.4,2.9c0.8,0.9,1.3,1.8,1.6,3c0.3,1.1,0.5,2.2,1,3.2c0.6,1.3,1.5,2.3,2.7,3.1 c0.5,0.3,1-0.5,0.5-0.8c-2-1.4-2.7-3.4-3.2-5.6c-0.2-1-0.6-1.9-1.2-2.8c-0.8-1-1.8-1.8-2.6-2.9c-1.7-2.3-1.5-5.3-2.9-7.8 c-0.6-1.1-1.4-2.2-2.4-3c-1.1-0.9-2.3-1.5-3.5-2.2c-1.4-0.7-2.4-1.7-3.3-3c-0.7-1.2-1.3-2.6-1.4-4.1 C239.5,12.4,238.5,12.4,238.6,13L238.6,13z",
    style: {
      fill: "rgb(47, 44, 73)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M213.4,41.3h-31.8c-2.8,0-5,2.3-5,5V50c0,2.8,2.3,5,5,5h31.8c2.8,0,5-2.3,5-5v-3.7 C218.5,43.5,216.2,41.3,213.4,41.3z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M218.5,46.6v-7.3c0-0.6-0.6-1.1-1.3-0.9l-7.3,2.8L218.5,46.6z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.2,47.3c-1.1,0-1.1,1.7,0,1.7C190.3,49,190.3,47.3,189.2,47.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.5,47.3c-1.1,0-1.1,1.7,0,1.7C198.6,49,198.6,47.3,197.5,47.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.8,47.3c-1.1,0-1.1,1.7,0,1.7C206.9,49,206.9,47.3,205.8,47.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 159.5,
    cy: 130,
    r: 120
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 130,
    r: 120,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11",
    style: {
      clipPath: "url('#SVGID_2_')",
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "115,251.7 137.8,375.3 135.1,375.3 105.9,251.7 \t\t\t\t\t",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "147,251.7 169.8,375.3 167.1,375.3 137.9,251.7 \t\t\t\t\t",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "67.6,251.7 44.8,375.3 47.5,375.3 76.7,251.7 \t\t\t\t\t",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.2,262.9c10.8,6.6,21.7,13.1,32.5,19.7c3.1,1.9,6.2,3.7,9.3,5.6c0.4,0.3,0.8-0.4,0.4-0.7 c-10.8-6.6-21.7-13.1-32.5-19.7c-3.1-1.9-6.2-3.7-9.3-5.6C67.2,261.9,66.8,262.6,67.2,262.9L67.2,262.9z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M109,261.3c-6,3.6-11.9,7.2-17.9,10.8c-6.1,3.7-12.2,7.4-18.4,11.1c-3.3,2-6.6,4-9.9,6 c-0.4,0.3,0,1,0.4,0.7c6-3.6,11.9-7.2,17.9-10.8c6.1-3.7,12.2-7.4,18.4-11.1c3.3-2,6.6-4,9.9-6 C109.8,261.7,109.4,261,109,261.3L109,261.3z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M56.9,173.3c0,0-14.7,56.2-4.1,74.8c10.6,18.6,62.1,12.9,72.4,6.4c10.3-6.4-22.4-66.5-22.4-66.5 L56.9,173.3z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M60.2,206.2c0.4,7,1.3,14.5,4.9,20.7c2.6,4.5,7.2,7.7,12.1,9.5c3.5,1.3,7.2,1.9,10.9,1.9 c0.5,0,0.5-0.8,0-0.8c-6,0-12.1-1.6-16.9-5.2c-1.9-1.4-3.6-3.1-4.9-5.1c-1.8-2.7-2.9-5.9-3.6-9.1c-1-3.9-1.4-7.9-1.6-11.9 C61,205.7,60.2,205.7,60.2,206.2L60.2,206.2z",
    style: {
      fill: "rgb(140, 117, 181)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M155.1,146.9l19.7,17.3l-5.7,27.6c0,0-23.6,2.8-34.7-22.6C123.3,143.9,155.1,146.9,155.1,146.9z",
    style: {
      fill: "rgb(224, 120, 94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M219.1,331.2c-0.8-2.8-1.9-5.5-2.9-8.2c-4.1-11-8.3-22.1-12.4-33.1c-4.1-11-8.3-22.1-12.4-33.1 c-2.1-5.5-4.1-11.1-6.2-16.6c-1.8-4.9-3.7-9.9-6-14.6c-4.2-8.4-10.4-16.4-19.3-20.1c-1.1-0.5-2.2-0.8-3.3-1.1 c-0.3-0.1-0.5,0.2-0.4,0.5c-0.2,0-0.4,0.1-0.7,0.2c-5.6,1.8-10.9,4.1-13.4,9.8c-2.5,5.7-1.9,12.3-5.5,17.5 c-2.1,3.1,1.2,6,4.1,5.4c3.6,10,7.2,19.9,10.8,29.9c4,11,7.9,22,11.9,33c2,5.5,4,11,5.9,16.5c1.8,5,3.5,10.1,5.5,15 c3,7.7,7.4,15.9,15.8,18.6c0.2,0.1,0.3,0.1,0.5,0.1c0.6,1.8,1.7,4.6,3.4,5.1c2.5,0.8,12.8,1.3,18.9-2.3 c2.7-1.6,2.6-4.5,1.6-7.1c2.1-2,3.8-4.6,4.6-7.5C220.3,336.4,219.8,333.7,219.1,331.2z",
    style: {
      fill: "rgb(81, 44, 38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M162.7,207.4c-4-4.5-17.5-3.2-25.3-3.2c-0.2-0.4,1.4-17.4,0.5-21.7h-51c-1.3-0.8-4.8-1.8-5.6,0 c-3.8,9-7,25.4-8.9,34.1c-1.8,8,0.1,15.7,6.5,20.4c6.2,4.7,14.2,5.9,21.7,6.7c1.1,0.1,2.3,0.3,3.4,0.4 c-0.1,0.2-0.3,0.3-0.4,0.5c-2.1,18.1-6.2,39.8-11.7,57.3c-3.3,10.8-7.2,22.9-4.6,34.3c1.1,4.9,3.9,9.4,7.6,12.2 c-0.4,2.8-0.1,6.2,3.8,7c6.9,1.5,18.2-0.6,19.9-2.6c0.6-0.8,0.8-2,0.8-3.2c0.9-0.2,1.7-0.4,2.5-0.8c4.6-1.9,6.5-6.7,7.7-11.1 c3.5-13.3,6.6-25.7,9.4-39.1c2.8-13.5,5.6-28,9.8-41.1c3.7-11.5,8.5-24.1,5.6-36.3c-0.2-0.8-0.4-1.6-0.7-2.4 c1.7-0.9,3.5-1.8,5.2-2.7C158.1,213.9,164.2,209.2,162.7,207.4z",
    style: {
      fill: "rgb(81, 44, 38)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M149.2,259.1c1.5-4.5,2.6-9.1,3.3-13.7c0.4-2.4,0.7-4.8,0.9-7.2c0.2-2,0.4-4,0.3-6 c-0.1-3.5-0.8-7-2.1-10.2c-0.7-1.8-1.7-3.5-2.9-5.1c-0.9-1.1-1.8-2.2-3-2.9c-3.6-2.3-7.7-4-11.7-5.3c-0.5-0.2-0.7,0.6-0.2,0.8 c3.7,1.2,7.4,2.8,10.8,4.8c1.1,0.6,1.8,1.3,2.7,2.2c1.3,1.4,2.3,3.1,3.1,4.8c1.5,3.2,2.3,6.7,2.4,10.2c0.1,1.8,0,3.5-0.1,5.3 c-0.2,2.4-0.5,4.8-0.8,7.1c-0.8,5.1-1.9,10.2-3.6,15.1C148.3,259.4,149.1,259.6,149.2,259.1L149.2,259.1z",
    style: {
      fill: "rgb(51, 22, 19)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M156.8,147.9c0,0-3.5-7.8-5.2-11.7c-1.6-3.5-3.1-7.1-4.9-10.6c-6.6-12.9-15.8-17.5-30-16.5 c-6,0.4-18.5,2-27.2,4.4c-5.5,1.5-10.4,5.1-13.8,8.1c-10.9,9.7-25.5,26-25.5,26c3.3,4,7.5,9.3,11.2,13c1.9,1.9,4.1,3.3,5.7,5.5 c0.8,1.1,1.4,2.2,2.1,3.4c0.7,1.2,1.5,2.1,2.7,2.5c0.8,0.3,1.7,0.4,2.6,0.5c0.9,0.1,1.7,0.3,2.6,0.3c0.5,0.1,1.1,0.1,1.6,0.1 c-0.4,3.5-0.8,6-1.4,9.9c3.6,0.8,17,2.6,25.6,3.2c16.8,1.2,33.5-2.5,33.6-2.9c0.5-5.9,1-13.1,1.5-19 C138.4,163.7,153.1,151.2,156.8,147.9z",
    style: {
      fill: "rgb(238, 88, 3)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.6,141.6c-2.9,3.7-5.7,7.4-8.6,11.1c-0.3,0.4,0.3,1,0.6,0.6c2.9-3.7,5.7-7.4,8.6-11.1 C94.5,141.7,94,141.2,93.6,141.6L93.6,141.6z",
    style: {
      fill: "rgb(186, 65, 4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M116.3,111.2c0.3,4.3,0.4,8.5,0.4,12.8c0.1,5.1,0,10.3,0,15.4c-0.1,5.5-0.2,11-0.4,16.4 c-0.2,5.2-0.5,10.4-0.8,15.6c-0.3,4.4-0.6,8.8-1.1,13.1c-0.1,0.5-0.1,0.9-0.2,1.4c-0.1,0.5,0.7,0.5,0.8,0 c0.5-4.2,0.8-8.5,1.1-12.7c0.4-5.1,0.6-10.2,0.8-15.4c0.2-5.5,0.4-10.9,0.5-16.4c0.1-5.2,0.1-10.4,0.1-15.6 c0-4.4-0.1-8.8-0.4-13.2c0-0.5-0.1-0.9-0.1-1.4C117.1,110.6,116.3,110.6,116.3,111.2L116.3,111.2z",
    style: {
      fill: "rgb(186, 65, 4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M54.4,143.6c5.1,5.2,10.2,10.5,15.3,15.7c0.4,0.4,0.9-0.2,0.6-0.6c-5.1-5.2-10.2-10.5-15.3-15.7 C54.6,142.6,54,143.2,54.4,143.6L54.4,143.6z",
    style: {
      fill: "rgb(186, 65, 4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M105.3,111.1c0.5,2.3,0.9,4.7,1.3,7c0.1,0.5,0.9,0.3,0.8-0.2c-0.4-2.3-0.8-4.7-1.3-7 C106,110.4,105.2,110.6,105.3,111.1L105.3,111.1z",
    style: {
      fill: "rgb(186, 65, 4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M107.1,118.4c3.3-0.8,6.6-1.7,9.8-2.7c0.5-0.1,0.3-0.9-0.2-0.8c-3.3,1-6.5,1.9-9.8,2.7 C106.4,117.8,106.6,118.5,107.1,118.4L107.1,118.4z",
    style: {
      fill: "rgb(186, 65, 4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M126.1,109.4c-0.1,2.6-0.1,5.3-0.1,7.9c0,0.5,0.8,0.5,0.8,0c0-2.6,0-5.3,0.1-7.9 C126.9,108.8,126.1,108.8,126.1,109.4L126.1,109.4z",
    style: {
      fill: "rgb(186, 65, 4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M126.5,116.9c-3.3-0.6-6.7-1.3-10-2.1c-0.5-0.1-0.7,0.7-0.2,0.8c3.3,0.8,6.6,1.4,10,2.1 C126.8,117.8,127,117,126.5,116.9L126.5,116.9z",
    style: {
      fill: "rgb(186, 65, 4)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M123.7,166.9c-0.4-3.1-7.5-11.6-10.7-14.8c-3.1-3.1-7-4.9-10.1-5.1c-5-0.4-10.6,1.5-15.2,2.7 c-5.8,1.6-11.6,3.5-17.3,5.5c-2.7,0.9-7,2.2-9.8,3.3c-1.3-0.9-7.6-7.6-9.5-9.6c-0.7,1-5,6.2-5.7,7.1c-3.3,4.6-6.7,9.8-7.7,15.4 c-1.8,10.7,7.1,20.3,17.9,19.1c1.5-0.2,18-7.6,25-11.7c6.8-3.9,13.7-7.3,20.9-10.4c0.1,1.5,0.4,2.9,1.3,3.6 c2.2,1.6,4.9,0.5,7.1-1c2.2-1.5,2.1-3.3,2.1-3.3c3.5,0.1,3.2-2.4,3.2-2.4C120.6,169.9,124.1,170,123.7,166.9z",
    style: {
      fill: "rgb(224, 120, 94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M227.5,146.3c0.3-5.4-3.3-10.8-8.9-11.2c-3.8-0.2-7.3,2-10.5,3.7c-3.5,1.9-7,3.8-10.5,5.7 c-5.1,2.8-31,15.2-33.6,17.6c-4.5,4.1-9.7,9.6-10.5,15.9c-0.8,6,3.1,11.1,8.7,12.9c6.7,2.2,13.4-0.7,19.2-3.8 c13-6.8,24.3-16.2,35.3-25.8C221.4,157.3,227.1,152.9,227.5,146.3z",
    style: {
      fill: "rgb(224, 120, 94)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M108,227.7c-2.3,5.3-3.9,10.8-4.8,16.5c-0.1,0.5,0.7,0.7,0.8,0.2c0.9-5.6,2.5-11.1,4.7-16.3 C108.9,227.6,108.2,227.2,108,227.7L108,227.7z",
    style: {
      fill: "rgb(51, 22, 19)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M191.6,351.3c6.5,1.1,13.6,0.9,19.7-2c1.3-0.6,2.6-1.4,3.8-2.4c0.4-0.3-0.2-0.9-0.6-0.6 c-4.5,3.7-10.7,4.9-16.4,4.8c-2.1,0-4.2-0.2-6.2-0.6C191.3,350.5,191.1,351.2,191.6,351.3L191.6,351.3z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M107.9,161c1.7,2,3.1,4.2,3.8,6.8c0.1,0.5,0.9,0.3,0.8-0.2c-0.8-2.7-2.3-5-4-7.1 C108.1,160,107.6,160.6,107.9,161L107.9,161z",
    style: {
      fill: "rgb(186, 90, 71)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M111,158.4c1.9,1.9,3.3,4.1,3.8,6.8c0.1,0.5,0.9,0.3,0.8-0.2c-0.6-2.8-2-5.2-4-7.1 C111.2,157.5,110.6,158,111,158.4L111,158.4z",
    style: {
      fill: "rgb(186, 90, 71)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M101.8,169.3c1.5-1,3-2,4.6-2.9c0.5-0.3,0-0.9-0.4-0.7c-1.6,0.9-3.1,1.8-4.6,2.9 c-0.2,0.1-0.3,0.4-0.1,0.6C101.4,169.3,101.6,169.4,101.8,169.3L101.8,169.3z",
    style: {
      fill: "rgb(186, 90, 71)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M212,137.4c0,0,4.1-8.7,9.2-17.9c4.6-8.4,5.6-9.3,7.2-8.8c2.4,0.7-0.2,9.6-1,11.8c0,0,5.6-4.3,9.9-6.2 c4.3-1.9,9.8-4,10.9-2.8c1.8,2-0.5,3.6-0.5,3.6s3.2,0.2,3.7,1.6c0.5,1.3-0.3,3.1-1,3.6c-0.3,0.2-8.8,4.3-8.8,4.3s9.2-2.1,9.8-2 c0.8,0.1,1.8,0.5,1.9,1.7c0.2,2-9.7,8-12.5,10.1c-2.8,2-11.5,13.3-18.2,19.8C222.6,156,213.7,142.7,212,137.4z",
    style: {
      fill: "rgb(224, 120, 94)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M247.3,116.9c-3.9,3.3-7.6,6.7-11.5,10c-0.4,0.3,0.2,0.9,0.6,0.6c3.9-3.3,7.6-6.7,11.5-10 C248.3,117.1,247.7,116.6,247.3,116.9L247.3,116.9z",
    style: {
      fill: "rgb(186, 90, 71)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M232.1,123.5c2.8,2.7,4.9,6.1,6.1,9.9c0.2,0.5,0.9,0.3,0.8-0.2c-1.2-3.9-3.4-7.4-6.3-10.2 C232.3,122.6,231.7,123.1,232.1,123.5L232.1,123.5z",
    style: {
      fill: "rgb(186, 90, 71)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M226.9,123.7c1,4.5,0.7,9.2-1,13.5c-0.2,0.5,0.6,0.7,0.8,0.2c1.7-4.4,2.1-9.3,1-14 C227.5,123,226.7,123.2,226.9,123.7L226.9,123.7z",
    style: {
      fill: "rgb(186, 90, 71)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M237.3,130c1.7-1.1,3.4-2.2,5.2-3.1c0.5-0.2,0.1-0.9-0.4-0.7c-1.8,0.9-3.5,2-5.2,3.1 C236.5,129.5,236.9,130.2,237.3,130L237.3,130z",
    style: {
      fill: "rgb(186, 90, 71)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M46.2,164.6c4.7-2,9.5-3.9,14.3-5.8c0.5-0.2,0.3-1-0.2-0.8c-4.8,1.9-9.7,3.8-14.4,5.9 C45.3,164.1,45.7,164.8,46.2,164.6L46.2,164.6z",
    style: {
      fill: "rgb(186, 90, 71)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M122.3,109.1c-1.1,2.3-3.9,7.4-5.6,6.9c-0.9-0.3-6-3.7-8.4-5.8c3.4-0.4,6.4-0.8,8.6-0.9 C118.7,109,120.6,109,122.3,109.1z",
    style: {
      fill: "rgb(224, 120, 94)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "122.6,104.1 121.9,109.7 108.2,110.1 109.9,98.8 \t\t\t\t\t",
    style: {
      fill: "rgb(224, 120, 94)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M95.1,349c6,1.6,12.4,2,18.6,1.7c1.8-0.1,3.7-0.3,5.5-0.6c0.5-0.1,0.3-0.9-0.2-0.8 c-6.3,1-12.9,0.9-19.1-0.2c-1.5-0.2-3-0.6-4.5-0.9C94.8,348.1,94.6,348.9,95.1,349L95.1,349z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 123.8,
    cy: 84,
    r: 7.4,
    style: {
      fill: "rgb(73, 49, 48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M112,101.8c3,2.2,7.6,4.7,13.7,5.5c5.9,0.8,7.8-3.8,7.4-5.8c-0.3-2-1.9-9.3-3.9-15.4s-4.3-8.9-12.1-9.4 c-7.7-0.5-14.3,2.2-14,10.2C103.4,94.9,109.8,100.2,112,101.8z",
    style: {
      fill: "rgb(224, 120, 94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M126.4,74.6c-1.1,0-2.1,0.3-2.9,0.8c-1.7-1.5-4.4-2.5-7.3-2.5c-4.1,0-7.5,1.9-8.9,4.5c0,0,0,0,0,0 c0,0-0.1,0.1-0.1,0.1c-2.8-0.1-5.5,1.6-6.7,4.2c-1.3,2.9-0.8,6.2,1.3,8.6c0.4,0.4,0.8,0.8,1.3,1.2c0.9,2.4,1.9,4.7,3.4,6.8 c0.8,1.1,1.7,2,2.7,2.8c0.7,0.6,2.8,2.1,3.9,1.5c2.2-1.1,3.1-2.9,3.3-4.1c1.1-3.2,1.1-4.7,0.4-8.1c3.7,0.6,7.6-2.2,9-5.8 c0.2,0,0.4,0,0.6,0c3,0,5.4-2.2,5.4-5C131.8,76.8,129.4,74.6,126.4,74.6z",
    style: {
      fill: "rgb(73, 49, 48)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M103,90.8c0.3,1.1,1.2,2,2.3,2.3c1.3,0.4,2.6,0,3.7-0.8c0.5-0.3,1.1-0.9,1.7-0.6 c0.3,0.1,0.6,0.3,0.9,0.5c0.3,0.1,0.5,0.2,0.8,0.2c1.2,0.2,2.3-0.2,3.2-1c0.4-0.4-0.2-0.9-0.6-0.6c-0.8,0.7-1.9,1-2.9,0.7 c-0.5-0.2-0.9-0.5-1.4-0.6c-0.5-0.1-0.9,0-1.3,0.3c-0.4,0.2-0.8,0.6-1.3,0.9c-0.5,0.3-1.1,0.5-1.8,0.5c-1.2,0-2.2-0.8-2.5-1.9 C103.6,90.1,102.8,90.3,103,90.8L103,90.8z",
    style: {
      fill: "rgb(73, 49, 48)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M107,79.8c0.3,2.5,3,4,5.3,2.7c0.2-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.5-0.5,0.8-0.6 c0.3-0.1,0.8,0.2,1.1,0.3c0.3,0,0.6,0,0.9,0c1.5-0.2,2.6-1.3,3.5-2.4c0.3-0.4-0.2-1-0.6-0.6c-0.8,0.9-1.7,1.9-3,2.1 c-0.3,0-0.6,0-0.9,0c-0.3-0.1-0.6-0.2-0.9-0.2c-0.5,0-0.9,0.2-1.2,0.5c-0.4,0.4-0.7,0.7-1.2,0.9c-0.5,0.2-1.1,0.2-1.6,0.1 c-1.1-0.3-1.9-1.2-2-2.3C107.7,79.3,106.9,79.2,107,79.8L107,79.8z",
    style: {
      fill: "rgb(73, 49, 48)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M121.7,83.2c0.8,1.3,2.4,1.9,3.9,1.6c0.5-0.1,0.3-0.9-0.2-0.8c-1.1,0.3-2.3-0.2-3-1.2 C122.1,82.4,121.4,82.8,121.7,83.2L121.7,83.2z",
    style: {
      fill: "rgb(73, 49, 48)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M109.5,101.2l-0.5,3.6c0,0,7.5,0.7,7.2-6.5C115.9,91.1,109.5,101.2,109.5,101.2z",
    style: {
      fill: "rgb(73, 49, 48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M130.2,89.8c0,0,2.3,1.8,3.5,3c0.7,0.6,0.6,1.2,0.2,1.6c-0.7,0.7-2,1.8-2,1.8l-3-1.9L130.2,89.8z",
    style: {
      fill: "rgb(224, 120, 94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M121.8,94.7c0,2.5-2,4.6-4.6,4.6c-2.5,0-4.6-2-4.6-4.6c0-2.5,2-4.6,4.6-4.6 C119.8,90.1,121.8,92.2,121.8,94.7z",
    style: {
      fill: "rgb(224, 120, 94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M127.9,90.6c-0.2-0.2-0.6-0.4-0.9-0.3c-0.4,0.1-0.6,0.5-0.6,0.8c0,0.4,0,0.8,0.1,1.1 c0.1,0.4,0.3,0.9,0.7,1.1c0.6,0.4,1.2,0,1.4-0.7C128.7,92,128.3,91,127.9,90.6z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M129,88.5c-0.1,1.4-1.4,0.7-2.7,1.5c-1.2,0.7-2.1,0.8-2.3,0.1c-0.2-0.9,0.8-2.3,2.7-2.8 C128.4,86.8,129.1,87.5,129,88.5z",
    style: {
      fill: "rgb(73, 49, 48)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.3,97.3c-1.7,0.6-3.5,1.2-3.8,1.2c1.2,0.8,2.8,1.1,4.3,1C132.7,98.8,132.5,98.1,132.3,97.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M117.2,104.9c1.4,0.8,3,1.6,4.5,2.2c0.2,0.1,0.4-0.1,0.5-0.3c0.1-0.2-0.1-0.4-0.3-0.5 c-1.5-0.6-2.9-1.3-4.3-2.1C117.1,103.9,116.7,104.6,117.2,104.9L117.2,104.9z",
    style: {
      fill: "rgb(186, 90, 71)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M116.2,92.4c-0.7,0.5-1.2,1.3-1.3,2.3c-0.1,0.9,0.3,1.8,0.9,2.5c0.4,0.4,0.9-0.2,0.6-0.6 c-1-1-0.9-2.7,0.3-3.5c0.2-0.1,0.3-0.4,0.1-0.6C116.7,92.3,116.4,92.2,116.2,92.4L116.2,92.4z",
    style: {
      fill: "rgb(186, 90, 71)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194.5,355.8c0,0-1.4,8.1,0.4,19.5h49c0,0,0.3-9.4-5.6-12.4c-3.1-1.6-14.4-5-15.9-6.6c0,0-2.5-1.9-4-4.2 c-3.2-4.8-7.2-3.1-8.7,1.1C209.7,353.3,203,356.7,194.5,355.8z",
    style: {
      fill: "rgb(245, 227, 217)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M194.7,371.4c6.2,0,12.4,0,18.6,0c6.6,0,13.2,0,19.8,0c3.3,0,6.7,0,10,0c0.5,0,0.5-0.8,0-0.8 c-6.2,0-12.4,0-18.6,0c-6.6,0-13.2,0-19.8,0c-3.3,0-6.7,0-10,0C194.2,370.6,194.2,371.4,194.7,371.4L194.7,371.4z",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M227.3,371c0.4-1.9,0.7-3.8,1.7-5.5c1-1.7,2.7-3.1,4.5-3.7c0.5-0.2,0.3-0.9-0.2-0.8 c-1.9,0.7-3.7,2.1-4.8,3.8c-1.2,1.8-1.6,3.9-2,5.9C226.5,371.3,227.2,371.5,227.3,371L227.3,371z",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M209.5,353.8c1.6,2.3,3.6,4.4,5.9,6c2.5,1.8,5.2,3,8,4.2c1.6,0.7,3.3,1.3,4.9,1.9 c0.5,0.2,0.7-0.6,0.2-0.8c-5.4-2.2-11.1-4-15.3-8.2c-1.1-1.1-2.1-2.3-3.1-3.6C209.8,353,209.2,353.4,209.5,353.8L209.5,353.8z ",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M223.3,363.5c0.6-0.7,1.2-1.5,1.9-2.2c0.7-0.7,1.3-1.4,2.1-2.1c0.4-0.3-0.2-0.9-0.6-0.6 c-0.7,0.7-1.4,1.4-2.1,2.1c-0.7,0.7-1.3,1.5-2,2.3c-0.1,0.2,0,0.4,0.1,0.5C223,363.7,223.2,363.7,223.3,363.5L223.3,363.5z",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M219,361.2c0.6-0.8,1.2-1.5,1.9-2.2c0.6-0.6,1.3-1.2,2.1-1.7c0.2-0.1,0.3-0.3,0.1-0.5 c-0.1-0.2-0.4-0.3-0.5-0.1c-0.8,0.6-1.5,1.1-2.2,1.8c-0.7,0.7-1.3,1.4-2,2.2c-0.1,0.2-0.2,0.4,0,0.6 C218.6,361.4,218.8,361.4,219,361.2L219,361.2z",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M214.4,358.2c0.8-0.7,1.7-1.4,2.6-2c0.9-0.6,1.8-1.2,2.8-1.6c0.2-0.1,0.2-0.4,0.1-0.5 c-0.1-0.2-0.3-0.2-0.5-0.1c-1,0.5-2,1.1-2.9,1.7c-0.9,0.6-1.8,1.3-2.7,2.1C213.4,358,214,358.5,214.4,358.2L214.4,358.2z",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M96.6,354.4c0,0-1.8,9.5,0,20.9h49c0,0,0.3-9.4-5.6-12.4c-3.1-1.6-14.4-5-15.9-6.6c0,0-2.5-1.9-4-4.2 c-3.2-4.8-7.2-3.1-8.7,1.1C111.4,353.3,105.1,355.3,96.6,354.4z",
    style: {
      fill: "rgb(245, 227, 217)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M96.4,371.4c6.2,0,12.4,0,18.6,0c6.6,0,13.2,0,19.8,0c3.3,0,6.7,0,10,0c0.5,0,0.5-0.8,0-0.8 c-6.2,0-12.4,0-18.6,0c-6.6,0-13.2,0-19.8,0c-3.3,0-6.7,0-10,0C95.9,370.6,95.9,371.4,96.4,371.4L96.4,371.4z",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M129.1,371c0.4-1.9,0.7-3.8,1.7-5.5c1-1.7,2.7-3.1,4.5-3.7c0.5-0.2,0.3-0.9-0.2-0.8 c-1.9,0.7-3.7,2.1-4.8,3.8c-1.2,1.8-1.6,3.9-2,5.9C128.2,371.3,129,371.5,129.1,371L129.1,371z",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M111.2,353.8c1.6,2.3,3.6,4.4,5.9,6c2.5,1.8,5.2,3,8,4.2c1.6,0.7,3.3,1.3,4.9,1.9 c0.5,0.2,0.7-0.6,0.2-0.8c-5.4-2.2-11.1-4-15.3-8.2c-1.1-1.1-2.1-2.3-3.1-3.6C111.6,353,110.9,353.4,111.2,353.8L111.2,353.8z ",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M125.1,363.5c0.6-0.7,1.2-1.5,1.9-2.2c0.7-0.7,1.3-1.4,2.1-2.1c0.4-0.3-0.2-0.9-0.6-0.6 c-0.7,0.7-1.4,1.4-2.1,2.1c-0.7,0.7-1.3,1.5-2,2.3c-0.1,0.2,0,0.4,0.1,0.5C124.7,363.7,124.9,363.7,125.1,363.5L125.1,363.5z",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M120.7,361.2c0.6-0.8,1.2-1.5,1.9-2.2c0.6-0.6,1.3-1.2,2.1-1.7c0.2-0.1,0.3-0.3,0.1-0.5 c-0.1-0.2-0.4-0.3-0.5-0.1c-0.8,0.6-1.5,1.1-2.2,1.8c-0.7,0.7-1.3,1.4-2,2.2c-0.1,0.2-0.2,0.4,0,0.6 C120.3,361.4,120.6,361.4,120.7,361.2L120.7,361.2z",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M116.1,358.2c0.8-0.7,1.7-1.4,2.6-2c0.9-0.6,1.8-1.2,2.8-1.6c0.2-0.1,0.2-0.4,0.1-0.5 c-0.1-0.2-0.3-0.2-0.5-0.1c-1,0.5-2,1.1-2.9,1.7c-0.9,0.6-1.8,1.3-2.7,2.1C115.2,358,115.7,358.5,116.1,358.2L116.1,358.2z",
    style: {
      fill: "rgb(46, 22, 22)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "38.8,194 -3.1,375.3 0.2,375.3 45.8,196.4 \t\t\t\t\t",
    style: {
      fill: "rgb(217, 163, 137)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "79.9,194 121.8,375.3 118.5,375.3 72.9,196.4 \t\t\t\t\t",
    style: {
      fill: "rgb(199, 228, 242)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M76.9,210.7c2.2,0,4.3,0,6.5,0c0.5,0,0.5-0.8,0-0.8c-2.2,0-4.3,0-6.5,0C76.3,209.9,76.3,210.7,76.9,210.7 L76.9,210.7z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M35.5,210.7c2.2,0,4.3,0,6.5,0c0.5,0,0.5-0.8,0-0.8c-2.2,0-4.3,0-6.5,0C35,209.9,35,210.7,35.5,210.7 L35.5,210.7z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M268.7,192.7H6.1c-1,0-1.9-0.8-1.9-1.9V190c0-1,0.8-1.9,1.9-1.9h262.6c1,0,1.9,0.8,1.9,1.9v0.8 C270.6,191.8,269.7,192.7,268.7,192.7z",
    style: {
      fill: "rgb(199, 228, 242)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1,
    y: 192.7,
    className: "st4",
    width: 240.2,
    height: 17.2,
    style: {
      fill: "rgb(199, 228, 242)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M83.7,210.3c0-5.8,0-11.7,0-17.5c0-0.5-0.8-0.5-0.8,0c0,5.8,0,11.7,0,17.5 C82.9,210.9,83.7,210.9,83.7,210.3L83.7,210.3z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M241.7,210.7c2.2,0,4.3,0,6.5,0c0.5,0,0.5-0.8,0-0.8c-2.2,0-4.3,0-6.5,0 C241.2,209.9,241.2,210.7,241.7,210.7L241.7,210.7z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M200.3,210.7c2.2,0,4.3,0,6.5,0c0.5,0,0.5-0.8,0-0.8c-2.2,0-4.3,0-6.5,0 C199.8,209.9,199.8,210.7,200.3,210.7L200.3,210.7z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M35.5,193.1c27.6,0,55.2,0,82.9,0c27.8,0,55.6,0,83.3,0c15.4,0,30.8,0,46.2,0c0.5,0,0.5-0.8,0-0.8 c-27.6,0-55.2,0-82.9,0c-27.8,0-55.6,0-83.3,0c-15.4,0-30.8,0-46.2,0C35,192.3,35,193.1,35.5,193.1L35.5,193.1z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 342.5,
    className: "st22",
    width: 106.8,
    height: 4.6,
    style: {
      fill: "rgb(217, 163, 137)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M104.6,188.7c0.4,0.9,0.4,2.1-0.1,3c-0.1,0.2-0.1,0.4,0.1,0.6c0.2,0.1,0.5,0,0.6-0.1 c0.6-1.2,0.6-2.6,0.1-3.8c-0.1-0.2-0.4-0.2-0.6-0.1C104.5,188.3,104.5,188.6,104.6,188.7L104.6,188.7z",
    style: {
      fill: "rgb(135, 205, 232)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M200.3,132.7h-63.9c-0.7,0-1.4,0.5-1.7,1.1l-21.9,54.3h67.9l21.4-52.9C202.5,134,201.6,132.7,200.3,132.7z ",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M129.5,185.1H87.1c-1,0-1.8,0.8-1.8,1.8v1.1h44.2V185.1z",
    style: {
      fill: "rgb(43, 36, 74)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M117.3,186.4c2.8-6.9,5.5-13.7,8.3-20.6c2.9-7.2,5.8-14.5,8.8-21.7c0.7-1.8,1.5-3.7,2.2-5.5 c0.4-0.9,0.7-1.8,1.1-2.7c0.4-1.1,1.1-1.9,2.1-2.5c0.5-0.2,0.1-0.9-0.4-0.7c-0.8,0.4-1.6,1.1-2,1.9c-0.4,0.7-0.7,1.6-1,2.3 c-0.7,1.7-1.3,3.3-2,5c-1.4,3.5-2.9,7.1-4.3,10.6c-3,7.4-6,14.8-9,22.3c-1.5,3.8-3,7.6-4.6,11.4 C116.3,186.7,117.1,186.9,117.3,186.4L117.3,186.4z",
    style: {
      fill: "rgb(140, 117, 181)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M114.5,185.2c0.2,0,0.3,0.1,0.5,0.1c0.2,0.1,0.2,0.1,0.4,0.2c0.3,0.2,0.5,0.3,0.7,0.6 c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1,0.1,0.2,0.1,0.4 c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4 c-0.1-1.5-1.4-2.9-2.9-3.2c-0.2,0-0.4,0.1-0.5,0.3C114.2,184.9,114.3,185.2,114.5,185.2L114.5,185.2z",
    style: {
      fill: "rgb(140, 117, 181)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M 160.1 166.4 C 158.5 166.4 157.29999999999998 165.8 156.5 164.70000000000002 C 155.7 163.50000000000003 155.5 161.9 156.1 160.3 C 157.2 157.10000000000002 160.79999999999998 154.5 164 154.5 C 165.6 154.5 166.8 155.1 167.6 156.2 C 168.4 157.39999999999998 168.6 159 168 160.6 C 166.8 163.8 163.3 166.4 160.1 166.4 Z",
    style: {
      fill: "rgb(140, 117, 181)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M 163.9 155.2 C 161 155.2 157.8 157.6 156.8 160.5 C 156.3 161.9 156.4 163.2 157.10000000000002 164.2 C 157.70000000000002 165.1 158.8 165.5 160.10000000000002 165.5 C 163.00000000000003 165.5 166.20000000000002 163.1 167.20000000000002 160.2 C 167.70000000000002 158.79999999999998 167.60000000000002 157.5 166.9 156.5 C 166.3 155.7 165.2 155.2 163.9 155.2 Z",
    style: {
      fill: "rgb(140, 117, 181)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M131.7,66h27.7c2.4,0,4.4-2,4.4-4.4v-3.2c0-2.4-2-4.4-4.4-4.4h-27.7c-2.4,0-4.4,2-4.4,4.4v3.2 C127.3,64,129.3,66,131.7,66z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M127.3,61.3v6.3c0,0.6,0.6,1,1.1,0.8l6.3-2.4L127.3,61.3z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.8,60.7c1,0,1-1.5,0-1.5C151.8,59.2,151.8,60.7,152.8,60.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.5,60.7c1,0,1-1.5,0-1.5C144.6,59.2,144.6,60.7,145.5,60.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.3,60.7c1,0,1-1.5,0-1.5C137.4,59.2,137.4,60.7,138.3,60.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.11edf276c5605e3c83ffcca63da8e54b.svg";
export { ForwardRef as ReactComponent };